import { lazy, Suspense } from "react";
import { RouteObject } from "../../helpers/tixxt-router";
import Loading from "../shared/Loading";

const DirectoryPage = lazy(
  () => import("../../components/directory/DirectoryPage"),
);
const GroupMembersPage = lazy(
  () => import("../../components/directory/GroupMembersPage"),
);

const directoryRoutes: RouteObject[] = [
  {
    path: "/directory",
    element: (
      <Suspense fallback={<Loading />}>
        <DirectoryPage preselectedTab="members" />
      </Suspense>
    ),
  },
  {
    path: "/members",
    element: (
      <Suspense fallback={<Loading />}>
        <DirectoryPage preselectedTab="members" />
      </Suspense>
    ),
  },
  {
    path: "/groups/:groupSlug/members",
    element: (
      <Suspense fallback={<Loading />}>
        <GroupMembersPage />
      </Suspense>
    ),
  },
  {
    path: "/channels",
    element: (
      <Suspense fallback={<Loading />}>
        <DirectoryPage preselectedTab="channels" />
      </Suspense>
    ),
  },
  {
    path: "/directory/channels",
    element: (
      <Suspense fallback={<Loading />}>
        <DirectoryPage preselectedTab="channels" />
      </Suspense>
    ),
  },
  {
    path: "/directory/distributions",
    element: (
      <Suspense fallback={<Loading />}>
        <DirectoryPage preselectedTab="distributions" />
      </Suspense>
    ),
  },
  {
    path: "/directory/:category_id",
    element: (
      <Suspense fallback={<Loading />}>
        <DirectoryPage preselectedTab="groups" />
      </Suspense>
    ),
  },
];

export default directoryRoutes;
